// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"310":"59c6f6ee","849":"8b8b11d0"}[chunkId] + ".js";
};